<template>
  <v-container fluid grid-list-sm px-1 pb-1 pt-2>
    <v-layout row wrap>
      <v-flex 
        v-for="banner in topBanners" 
        :key="banner.id" 
        :style="styleFlex(topBanners.length)" 
        @click="goToLink(banner)"
        class="j-banner"
      >
        <img :src="banner.image" alt="lorem" width="100%" height="100%">
      </v-flex>

      <v-flex 
        v-for="banner in bottomBanners" 
        :key="banner.id" 
        :style="styleFlex(bottomBanners.length)" 
        @click="goToLink(banner)"
        class="j-banner"
      >
        <img :src="banner.image" alt="lorem" width="100%" height="100%">
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data: () => ({
    banners: []
  }),
  methods: {
    ...mapActions("links", ["fetchLinks"]),
    async getBanners() {
      let view_as = localStorage.getItem("view_as")
      const res = await this.fetchLinks(view_as)
      this.banners = res.links
    },
    styleFlex(length) {
      const width = 100 / length
      return `width: ${width}%;`
    },
    getIndexSlice() {
      return Math.floor(this.banners.length / 2)
    },
    goToLink(banner) {
      if (banner.is_blank == true) window.open(banner.url, "_blank");
      else window.open(banner.url, "_self");
    },
  },
  computed: {
    topBanners() {
      return this.banners.slice(0, this.getIndexSlice())
    },
    bottomBanners() {
      return this.banners.slice(this.getIndexSlice())
    }
  },
  created() {
    this.getBanners()
  },
}
</script>
<style lang="css" scoped>
.j-banner {
  height: auto;
  padding: 0.5px 0.5px !important;
  cursor: pointer;
}
</style>